import { useEffect, useState } from 'react';
import { Loader2, FileText, Image as ImageIcon } from 'lucide-react';
import { FLYER_API, flyerError } from '../../hooks/useServiceFlyer';

export const ServiceFlyerPreview = ({ slug, content, auth }) => {
  const [layout, setLayout] = useState('a4');
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true); setError('');
    const timer = setTimeout(async () => {
      try {
        const response = await fetch(`${FLYER_API}/admin/service-flyers/${slug}/preview?layout=${layout}`, {
          method: 'POST', headers: { ...auth, 'Content-Type': 'application/json' },
          body: JSON.stringify(content), signal: controller.signal,
        });
        if (!response.ok) throw new Error(await flyerError(response));
        const blob = await response.blob();
        if (!controller.signal.aborted) setUrl(URL.createObjectURL(blob));
      } catch (err) { if (err.name !== 'AbortError') setError(err.message); }
      finally { if (!controller.signal.aborted) setLoading(false); }
    }, 600);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [content, slug, layout, auth]);
  useEffect(() => () => { if (url) URL.revokeObjectURL(url); }, [url]);

  return <section className="lg:sticky lg:top-24" data-testid="service-flyer-preview">
    <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
      <h2 className="text-sm font-bold text-foreground">Preview</h2>
      <div className="flex rounded-md border border-border bg-white p-1">
        {[['a4', 'A4', FileText], ['social', '4:5', ImageIcon]].map(([key, label, Icon]) => <button key={key} type="button" onClick={() => setLayout(key)} aria-pressed={layout === key}
          data-testid={`flyer-preview-${key}`} className={`inline-flex items-center gap-1.5 rounded px-3 py-1.5 text-xs transition-colors ${layout === key ? 'bg-primary text-white' : 'hover:bg-gray-100'}`}><Icon className="h-3.5 w-3.5" />{label}</button>)}
      </div>
    </div>
    <div className="relative overflow-hidden rounded-lg border border-border bg-white shadow-sm" style={{ aspectRatio: layout === 'a4' ? '210/297' : '4/5' }}>
      {url && !error && <img src={url} alt={`${content.title} ${layout === 'a4' ? 'A4' : 'social'} flyer preview`} data-testid="flyer-preview-image" className={`h-full w-full object-contain transition-opacity ${loading ? 'opacity-40' : 'opacity-100'}`} />}
      {loading && <div className="absolute inset-0 flex items-center justify-center" role="status" data-testid="flyer-preview-loading"><Loader2 className="h-7 w-7 animate-spin text-primary" /><span className="sr-only">Updating preview</span></div>}
      {error && <div role="alert" className="absolute inset-0 flex items-center justify-center p-6 text-sm text-red-700" data-testid="flyer-preview-error">{error}</div>}
    </div>
  </section>;
};